











import { Component, Vue } from 'vue-property-decorator';
import MyNav from '@/components/nav/Index.vue';
import { Getter } from 'vuex-class';
// nav
    @Component({
      components: {
        MyNav,
      },
    })
export default class extends Vue {
        @Getter public bcgBack :any;

        @Getter public bcgImg :any;

        @Getter public bcgTitle :any;

        @Getter public bcgLeftBlock :any;
}
